import React, { useState } from 'react';
import JsonPatientForm from './JsonPatientForm';
import TestResults from './TestResults';
import TagManagement from './TagManagement';
import ComparativeAnalysis from './ComparativeAnalysis';

const Tabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Tab configuration with icons (using Unicode symbols)
  const TAB_CONFIG = [
    {
      id: 0,
      label: 'Test Results',
      icon: '📊',
      component: <TestResults onSwitchToComparative={() => setActiveTab(2)} />
    },
    {
      id: 1,
      label: 'Upload Test',
      icon: '📁',
      component: <JsonPatientForm />
    },
    {
      id: 2,
      label: 'Comparative Analysis',
      icon: '📈',
      component: <ComparativeAnalysis />
    },
    {
      id: 3,
      label: 'Tag Management',
      icon: '🏷️',
      component: <TagManagement />
    }
  ];

  return (
    <div className="tabs-container">
      {/* Modern Tab Navigation */}
      <nav className="tabs-header" role="tablist">
        {TAB_CONFIG.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={activeTab === tab.id ? 'active' : ''}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`tabpanel-${tab.id}`}
          >
            <span className="tab-icon" aria-hidden="true">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </nav>

      {/* Tab Content Area */}
      <div
        className="tabs-content"
        role="tabpanel"
        id={`tabpanel-${activeTab}`}
        aria-labelledby={`tab-${activeTab}`}
      >
        {TAB_CONFIG[activeTab].component}
      </div>
    </div>
  );
};

export default Tabs;